/**
 * The heading block every shell page opens with: title, optional supporting
 * line, and a right-aligned action group that wraps under the title at `sm`.
 *
 * Pages currently open with a bare `<h2>` followed by a paragraph of links
 * (see InvoiceListPage). Routing those through one component is what makes the
 * spacing above the content identical from page to page, which is the thing
 * the old element-level stylesheet was doing implicitly.
 *
 * The title stays an `<h2>`: the shell header already renders the page's `<h1>`,
 * and skipping a level would break the document outline the tests query.
 */
import type { ReactNode } from 'react';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Buttons or links for this page, laid out inline at the end of the header row. */
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps): React.JSX.Element {
  return (
    <div className="page-header">
      <div className="page-header__text">
        <h2 className="page-header__title">{title}</h2>
        {subtitle !== undefined && <p className="page-header__subtitle">{subtitle}</p>}
      </div>
      {actions !== undefined && <div className="page-header__actions">{actions}</div>}
    </div>
  );
}

export default PageHeader;
